<template>
  <div class="st-root">
    <div class="st-grid">
      <div class="st-field st-field-input">
        <label class="st-label-search">Pesquisar</label>
        <div class="st-inputwrap">
          <i class="fa-solid fa-magnifying-glass st-icon"></i>
          <input class="st-input" type="text" v-model="draft.query"
                 placeholder="Pesquisa e enter..."
                 @keyup.enter="onSearch"/>
          <button v-if="showClearButton" class="st-btn-clear" @click="onClear">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>

      <div class="st-field st-div-select">
        <label class="st-label">Categoria</label>
        <Select url="/api/v1/stock/category-product/select-all" :showNewRegister="false"
                v-model="draft.category" :cleaned="() => cleaned('category')">
        </Select>
      </div>

      <div class="st-field st-div-select">
        <label class="st-label">Fabricante</label>
        <Select url="/api/v1/stock/manufacturer/select-all" :showNewRegister="false"
                v-model="draft.manufacturer" :cleaned="() => cleaned('manufacturer')">
        </Select>
      </div>

      <div class="st-actions">
        <Button _key="btnSearch" type="info" classIcon="fa-solid fa-magnifying-glass" size="small" :clicked="onSearch" />
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import {mapMutations} from "vuex";

export default {
  name: "SearchToolbarClean",
  components: {Button, Select},
  props: {
    value: {
      type: Object,
      default: () => ({
        query: "",
        category: null,
        manufacturer: null,
      }),
    },
  },
  data() {
    return {
      draft: {...this.value},
    };
  },
  computed: {
    showClearButton() {
      const query = (this.draft.query || "").trim();
      const hasCategory = this.hasSelection(this.draft.category);
      const hasManufacturer = this.hasSelection(this.draft.manufacturer);

      return query !== "" || hasCategory || hasManufacturer;
    },
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    hasSelection(value) {
      if (!value) {
        return false;
      }

      const id = String(value.id || "").trim();
      const content = String(value.content || "").trim();
      return id !== "" || content !== "";
    },
    emitAll() {
      this.$emit("input", this.draft);
      this.$emit("search", this.draft);
    },
    onSearch() {
      this.emitAll();
      this.removeLoading(["btnSearch"]);
    },
    onClear() {
      this.draft = {
        query: "",
        category: {id: "", content: ""},
        manufacturer: {id: "", content: ""},
      };
      this.emitAll();
    },
    cleaned(field) {
      if (field === "query") {
        this.draft.query = "";
      }

      if (field === "category") {
        this.$set(this.draft, "category", {id: "", content: ""});
      }

      if (field === "manufacturer") {
        this.$set(this.draft, "manufacturer", {id: "", content: ""});
      }

      this.emitAll();
    }
  },
  watch: {
    'draft.query'(newValue, oldValue) {
      const nextQuery = (newValue || "").trim();
      const previousQuery = (oldValue || "").trim();

      if (nextQuery === "" && previousQuery !== "") {
        setTimeout(() => {
          if ((this.draft.query || "").trim() === "") {
            this.onClear();
          }
        }, 1000);
      }
    },
    value: {
      deep: true,
      handler(v) {
        this.draft = {...v};
      },
    }
  }
};
</script>

<style scoped>
.st-root {
  font-size: 13px;
  padding: 0 0 12px 0;
}

.st-grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr auto;
  gap: 10px;
  align-items: end;
}

@media (max-width: 900px) {
  .st-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 600px) {
  .st-grid {
    grid-template-columns: 1fr;
  }
}

.st-field {
  display: flex;
  flex-direction: column;
}

.st-field-input {
  padding-top: 14px;
  padding-bottom: 3px;
}

.st-div-select {
  margin-bottom: -7px;
}

.st-label-search {
  color: #475569;
  font-weight: 500;
  font-size: 12px;
  margin-bottom: 4px;
}

.st-label {
  color: #475569;
  font-weight: 500;
  font-size: 12px;
  margin-bottom: -24px;
}

.st-field-input .st-inputwrap {
  height: 37px;
}

.st-inputwrap {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #dadadb;
  border-radius: 6px;
  padding: 0 8px;
  height: 36px;
  background: #fff;
}

.st-icon {
  color: #94a3b8;
  font-size: 13px;
  flex-shrink: 0;
}

.st-input {
  border: none;
  outline: none;
  background: transparent;
  height: 100%;
  font-size: 13px;
  color: #0f172a;
  flex: 1;
  min-width: 0;
}

.st-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-bottom: 7px;
}

.st-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  padding: 0 13px;
  border-radius: 50px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all .18s ease;
  height: 36px;
}

.st-btn-primary {
  color: white;
  background: #4ab4e2;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .06);
}

.st-btn-primary:active {
  transform: translateY(1px);
}

.st-btn-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e5e7eb;
  border: none;
  color: #6b7280;
  font-size: 11px;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
}

.st-btn-clear:hover {
  background: #d1d5db;
  color: #374151;
}
</style>
